<template>
  <p class="item-selected m-0" v-html="`Selected: ${Object.keys(ids).length} ${Object.keys(ids).length > 1 ? 'items' : 'item'}`"></p>
</template>
<script>
export default {
  props: {
    config: Object
  },
  data() {
    return {
      ids: {}
    }
  },
  computed: {
    store() {
      return this.config?.store
    },
    cb() {
      return this.config?.cb
    },
    rows() {
      let data = this.store.getter('rows', {})
      let rows = {}
      Object.entries(data).forEach(([indexRow, item]) => {
        rows[item._id] = item
        rows[item._id].indexRow = indexRow
      })
      return rows
    }
  },
  watch: {
    cb: {
      handler(values) {
        Object.entries(values).forEach(([id, checked]) => {
          if (checked) {
            this.ids[id] = true
          } else if (this.ids[id] != undefined) {
            delete this.ids[id]
          }
        })
      },
      deep: true
    }
  }
}
</script>
